import React, { useEffect, useMemo, useState } from 'react';
import claimProjectReportsListsService from '../services/lists/claim_groups/claim_project_reports_lists.service';
import ClaimProjectReportsList from '@components/admin/claimProjectReports/ClaimProjectReportsList';
import { buildQueryString } from '../services/service';
import Pagination from '../util/Pagination';
import { Loading } from '../util';
import { PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR, PROJECT_OVERVIEW_TABLE, PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON, PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS } from '@rd-web-markets/market/dist/constants';
import { useTableColumnSelectorConfig } from '../util/Table/useTableColumnSelectorConfig';
const initialParams = {
  page: 1,
  order_by: 'report_order',
  group_projects: 'default',
  query: ''
};
const PROJECT_OVERVIEW_TABLE_NAME = 'project_overview_table';

/**
 * Currently this component renders the list of projects with headers as defined in the constant files for each market.
 * However in order to reuse the functionality for othe pages, that more or less render the same things, we now have the 
 * customHeaders and customColumns array properties.
 * @param {*} param0 
 * @returns 
 */
export default function ProjectsList(_ref) {
  let {
    claimGroup,
    setClaimGroup,
    additionalQueryParams = {},
    mandatoryParams = {},
    customHeaders = null,
    customColumns = null,
    accountType,
    handleToaster,
    groupProjects = 'default',
    renderExpandedRowContent = null,
    isTechnicalNarrativePage = false
  } = _ref;
  const [loading, setLoading] = useState(false);
  const columnParams = useMemo(() => ({
    claimGroup
  }), [claimGroup]);
  const tableColumnSelectorConfig = useTableColumnSelectorConfig({
    tableName: PROJECT_OVERVIEW_TABLE_NAME,
    emptyColumnSelectorJson: PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON,
    minimumRequiredColumns: PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS,
    tableConfig: PROJECT_OVERVIEW_TABLE,
    columnParams,
    enabled: PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR,
    setLoading
  });
  const selectedProjectOverviewTableConfig = tableColumnSelectorConfig.selectedTableConfig;
  const selectedProjectFields = useMemo(() => {
    if (!PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR) {
      return [];
    }
    if (!selectedProjectOverviewTableConfig) {
      return PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS;
    }
    return selectedProjectOverviewTableConfig.selectedBackendFields;
  }, [selectedProjectOverviewTableConfig]);
  const selectedProjectFieldsQuery = useMemo(() => selectedProjectFields.join(','), [selectedProjectFields]);
  const [reports, setReports, totalPages, setTotalPages, params, setParams, fetchAllProjetcs, totalCostSum, totalQeSum] = claimProjectReportsListsService.useFetchAll({
    accountType,
    claimGroupId: claimGroup.id,
    initialQueryParams: buildQueryString({
      ...initialParams,
      ...additionalQueryParams,
      fields: selectedProjectFieldsQuery
    }),
    setLoading,
    groupProjects
  });
  useEffect(() => {
    if (!PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR) {
      return;
    }
    if (params.fields === selectedProjectFieldsQuery) {
      return;
    }
    setReports(null);
    setParams(currentParams => {
      if (currentParams.fields === selectedProjectFieldsQuery) {
        return currentParams;
      }
      return {
        ...currentParams,
        fields: selectedProjectFieldsQuery
      };
    });
  }, [params.fields, selectedProjectFieldsQuery, setParams, setReports]);
  const handlePage = pageNumber => {
    window.scrollTo(0, 0);
    setParams({
      ...params,
      page: pageNumber
    });
  };
  const tableColumnSelectorProps = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? {
    columnParams,
    columnSelectorConfig: tableColumnSelectorConfig
  } : null;
  const isProjectFieldsRequestPending = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR && params.fields !== selectedProjectFieldsQuery;
  const isProjectOverviewTableConfigLoading = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR && !selectedProjectOverviewTableConfig;
  if (!reports || isProjectFieldsRequestPending || isProjectOverviewTableConfigLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loading, null));
  }
  const passDownCustomHeaders = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? customHeaders || selectedProjectOverviewTableConfig.headers : customHeaders;
  const passDownCustomColumns = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? customColumns || selectedProjectOverviewTableConfig.columns : customColumns;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimProjectReportsList, {
    isTechnicalNarrativePage: isTechnicalNarrativePage,
    handleToaster: handleToaster,
    claimGroup: claimGroup,
    getData: fetchAllProjetcs,
    setClaimGroup: setClaimGroup,
    reports: reports,
    setReports: setReports,
    params: params,
    setParams: setParams,
    groupProjects: groupProjects,
    customHeaders: passDownCustomHeaders,
    customColumns: passDownCustomColumns,
    renderExpandedRowContent: renderExpandedRowContent,
    totalCostSum: totalCostSum,
    totalQeSum: totalQeSum,
    tableColumnSelectorProps: tableColumnSelectorProps
  }), /*#__PURE__*/React.createElement(Pagination, {
    currentPage: Number(params.page),
    totalPages: totalPages,
    handlePageChange: handlePage
  }));
}